module.exports = __webpack_public_path__ + "img/Picture1.a34ddac6.jpg";